import React from 'react';
import Unit from './../units/singleUnitComponent';
import NoResults from './../no_results/noResultsComponent';

class AUnits extends React.Component {
  render() {
    let total = this.props.count;
    let resultMsg = total === 0 ? 'No ' +this.props.searchResultName+' found' : '<strong>' + total + '</strong> '+this.props.searchResultName+' found';

    return <div className="all-units-wrap">
      <h2>All Units</h2>
        { this.props.initLoad ? null :
              <p className="result-msg" dangerouslySetInnerHTML={{__html: resultMsg}} /> }
      <ul>
        {
          this.props.result.length > 0 ? this.props.result.map(function(item, i) {
                                  return <Unit key={i}
                                               data={item}
                                               comparedUnits={this.props.comparedUnits}
                                               dispatchReducer={this.props.dispatchReducer} />;
                                  }, this) : <NoResults msg={'No Units were found.'} />
        }
      </ul>
    </div>;
  }
}

AUnits.propTypes = {
  result:          React.PropTypes.array.isRequired,
  options:         React.PropTypes.object.isRequired,
  comparedUnits:   React.PropTypes.array.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default AUnits;
